import { GetCrecaTradesApi } from "@/features/accounts/creca/services/get-trades-api";
import { GetCrecaTradesRequestModel } from "@/features/accounts/creca/services/get-trades-model";

/// クレカ明細一覧取得処理
export class GetCrecaTradesService {
  private getCrecaTradesApi = new GetCrecaTradesApi();

  /**
   * クレカ明細一覧取得API実行
   */
  public async getCrecaTrades(param: GetCrecaTradesRequestModel) {
    return await this.getCrecaTradesApi.getCrecaTrades(param);
  }
}
